import { useBoomWallet } from '@boomeme/wallet-sdk';
import Login from './components/Login';
import AccountView from './components/AccountView';

export default () => {
  const { isConnected } = useBoomWallet();

  return isConnected ? <AccountView /> : <Login />;
};
